var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.73 2.89048L20.29 7.00048C21.3567 7.77576 21.9914 9.01185 22 10.3305V17.7705C21.94 20.1637 19.9534 22.0564 17.56 22.0005H6.44C4.04665 22.0564 2.06002 20.1637 2 17.7705V10.3405C2.0061 9.01612 2.64544 7.77462 3.72 7.00048L9.27 2.89048C10.8964 1.70317 13.1036 1.70317 14.73 2.89048ZM17.56 20.5005C19.1251 20.5568 20.4404 19.3354 20.5 17.7705V10.3305C20.4948 9.48583 20.0812 8.6959 19.39 8.21048L13.84 4.10048C12.7439 3.30006 11.2561 3.30006 10.16 4.10048L4.61 8.20048C3.91817 8.69448 3.50534 9.4904 3.5 10.3405V17.7705C3.56502 19.333 4.87698 20.5512 6.44 20.5005H17.56Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.c9edd834dad57591618454114061d9ed.svg";
export { ForwardRef as ReactComponent };